<template>
  <div class="livingService">
    <BannerVideo :video-url="$StaticFileUrl + '/mp/video/livingServerBanner_product_2.mp4'">
      <div class="title wow fadeInDown" data-wow-duration="1s">便民生活缴费服务</div>
      <div class="desc wow fadeInDown" data-wow-duration="1s">为广大用户提供更加便捷的水、电、燃气、物业、宽带、话费、流量、<br>违章罚款等日常生活缴费服务，为企业打造基础民生生态体系，提高企<br>业竞争力</div>
      <div class="flex-row flex-col-center">
        <div class="btn-red wow flipInX" data-wow-duration="1s" style="margin-top: 100px">立即体验</div>
      </div>
    </BannerVideo>
  </div>
</template>

<script>
import WOW from 'wowjs'
import BannerVideo from '@/components/BannerVideo'

/**
 * @author  XuHongli
 * @date  2022/12/28 10:12
 * @version 1.0
 * @description
 */
export default {
  name: 'LivingService',
  components: {BannerVideo},
  mounted() {
    new WOW.WOW().init()
  }
}
</script>

<style scoped>

</style>
